// AccidentsDashboardCompanyBlade/index.js
import React from 'react';
import { Paper, Typography, Button, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import moment from 'moment';

import DashboardCountBox from '../../DashboardPanel/DashboardCountBox';
import { buttonNames } from '../../../constants';
import { injuryMappers } from '../../../mappers';
import { utcToLocal } from './../../../utils/timeConverter';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 16,
    margin: 16
  },
  titleContainer: {
    position: 'relative',
    top: -16
  },
  bladeIcon: {
    position: 'absolute'
  },
  bladeTitle: {
    marginTop: -4,
    position: 'absolute',
    left: 32,
    top: 6
  },
  countBoxContainer: {
    display: 'flex',
    marginTop: 24
  },
  countBox: {
    width: '100%'
  },
  container: {
    borderBottom: `1px solid ${theme.palette.lightGrey.default}`,
    padding: '10px 16px 10px 0',
    display: 'flex',
    justifyContent: 'space-between'
  },
  heading: {
    fontWeight: 600
  },
  textContent: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  textOuter: {
    width: '100%'
  },
  buttonContent: {},
  seeMoreButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8
  },
  seeMoreButton: {
    background: '#54a000',
    color: 'white',
    width: 150,
    height: 36,
    '&:hover': {
      background: 'white',
      color: '#54a000',
      border: '1px solid #54a000'
    }
  },
  noRecords: {
    fontSize: 20,
    textAlign: 'center',
    color: '#424242',
    marginBottom: 0
  },
  accidentDate: {
    margin: 0,
    marginTop: 8
  },
  subHeading: {
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginBottom: 3
  }
}));

function AccidentsDashboardCompanyBlade(props) {
  const classes = useStyles();

  const {
    fetchAllAccidentsForCompany,
    companyId,
    allAccidents,
    setCurrentBranchesRecord
  } = props;

  let accidents = allAccidents;

  React.useEffect(
    () => {
      if (companyId) {
        fetchAllAccidentsForCompany(companyId);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [companyId]
  );

  if (accidents.length > 0) {
    accidents = accidents.filter((item) => item.count > 0);
  }

  let initialValue = 0;
  const totalCount = accidents.reduce(
    (acc, curr) => acc + curr.count,
    initialValue
  );

  const handleSeeMoreButtonForAccidentsClick = (recordType) => {
    setCurrentBranchesRecord(recordType);
  };

  return (
    <Paper className={classes.paper}>
      <React.Fragment>
        <h3 className={classes.titleContainer}>
          <WarningIcon className={classes.bladeIcon} />
          <span className={classes.bladeTitle}>Accidents</span>
        </h3>

        <div className={classes.countBoxContainer}>
          <div className={classes.countBox}>
            <DashboardCountBox count={totalCount} label="in the past month" />
          </div>
        </div>

        {accidents &&
          accidents.map((accident, index) => {
            if (index > 9) {
              return null;
            }

            return (
              <div className={classes.container} key={index}>
                <div className={classes.textOuter}>
                  <div className={classes.textContent}>
                    <Typography variant="h6" className={classes.heading}>
                      {accident.branchName}
                    </Typography>
                    <div className={classes.buttonContent}>
                      <Link
                        href={`/admin-view/branch/${accident.branchId}`}
                        target="_blank"
                        className={classes.viewAsAdminButton}
                      >
                        go to branch
                      </Link>
                    </div>
                  </div>
                  <Typography
                    variant="subtitle1"
                    className={classes.subHeading}
                  >
                    {accident.count} accidents
                  </Typography>
                </div>
              </div>
            );
          })}

        {/* {accidents.length > 5 ? (
          <div className={classes.seeMoreButtonContainer}>
            <Button
              color="secondary"
              className={classes.seeMoreButton}
              onClick={() =>
                handleSeeMoreButtonForAccidentsClick(buttonNames.ACCIDENTS)
              }
            >
              See More
            </Button>
          </div>
        ) : null} */}
      </React.Fragment>
    </Paper>
  );
}

export default AccidentsDashboardCompanyBlade;
